














import LoginButton from '@spa/components/pages/auth/login/components/button/LoginButton.vue'
import { AsLoginForm } from '@spa/components/pages/auth/login/components/mixin/as-login-form'
import LoginWithoutIcon from '@spa/components/pages/auth/login/LoginWithoutIcon.vue'
import ContinueShopping from '@spa/components/pages/cart/components/login/default/button/ContinueShopping.vue'
import LoadingMixin from '@spa/mixins/loading'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'
@Component({
  components: { LoginButton, ContinueShopping, LoginWithoutIcon },
})
export default class CartLoginWithoutIcon extends Mixins<AsLoginForm & LoadingMixin>(AsLoginForm, LoadingMixin) {
  @Prop({ required: true })
  /**
   * @see LoginPageProps.next
   * @see AsLoginForm.next
   */
  readonly next: string

  get urlToContinueShopping() {
    return this.$store.getters['history/urlToContinueShopping']
  }
}
